
document.addEventListener('DOMContentLoaded', () => {

    updatePurchasePrice();

    const plusQuantityBtn = document.getElementsByClassName('product-quantity__plus qty-plus no-js-hidden')[0];
    const minusQuantityBtn = document.getElementsByClassName('product-quantity__minus qty-minus no-js-hidden')[0];
    const quantityInput = document.getElementsByClassName('product-quantity__selector qty-selector text-size--xlarge')[0];

    plusQuantityBtn.addEventListener('click', (evt) => {
        updatePurchasePrice();
    });

    minusQuantityBtn.addEventListener('click', (evt) => {
        updatePurchasePrice();
    });

    quantityInput.addEventListener('focusout', (evt) => {
          updatePurchasePrice();
    });
    checkAvailability();
});

document.getElementById('test_buy_button').addEventListener('click', (evt) =>{
    // console.log('Test but button clicked!');
    onTestSubmitHandler(evt);
});

function checkAvailability() {
  let selectedStore = localStorage.getItem("selected-store");
  if (!selectedStore) {
      console.log("No store selected. Keeping Add to Cart button enabled.");
      return;
  }
  let storeItems = document.querySelectorAll(".store-item[data-collection='test-1']");
  let addToCartButton = document.getElementById("test_buy_button");
  if (!addToCartButton) {
      console.error("Add to Cart button not found in DOM.");
      return;
  }
  let isAvailable = false;
  for (let item of storeItems) {
    let locationName = item.getAttribute("data-location-name");
    let availability = item.getAttribute("data-available") === "true";

    if (locationName === selectedStore && availability) {
        isAvailable = true;
        break;
    }
  }

  // Show or Hide Add to Cart buttons for chemical 1
  setTimeout(() => {
      if (!isAvailable) {
          addToCartButton.disabled = true;
          addToCartButton.setAttribute("aria-disabled", "true");
          addToCartButton.style.pointerEvents = "none";
          addToCartButton.textContent = "Sold Out";
          addToCartButton.style.opacity = "0.5";
      } else {
          addToCartButton.disabled = false;
          addToCartButton.removeAttribute("aria-disabled");
          addToCartButton.textContent = "Add to Cart";
          addToCartButton.style.pointerEvents = "auto";
          addToCartButton.style.opacity = "1";
      }
  }, 200);
}

const updatePurchasePrice = () =>{
    const unitPrice = Number(document.getElementById('hdn-product-unit-price').value) / 100;
    let quantity = Number(document.querySelector('[name="quantity"]').value);
    let totalPrice = unitPrice*quantity;

    document.getElementById('add-test-custom-product-price').innerHTML = `<span style="font-size: 40px; font-family: sans-serif; font-weight: 700; line-height: 48.76px;">${testAddToCartToCurrency(totalPrice.toFixed(2))}</span>`
}

function testAddToCartToCurrency(number) {
    let formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      trailingZeroDisplay: "stripIfInteger"
    });
    return formatter.format(number)
}

const onTestSubmitHandler = (e) => {	

    e.preventDefault();
    const productForm = document.querySelector('form[action="/cart/add"');
    const ADD_TO_CART = new Event('add-to-cart');
    const submitButton = document.querySelector('[type="submit"]');
    submitButton.classList.add('working');
    let cartType = productForm.hasAttribute('data-ajax-cart') ? 'ajax' : 'page';
    const requestBody = _serializeForm(productForm);
    let alert = '';

    fetch(`${KROWN.settings.routes.cart_add_url}.js`, {
        body: JSON.stringify(requestBody),
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST'
    })
        .then(response => response.json())
        .then(response => {
            if ( response.status == 422 ) {
                // wrong stock logic alert
                alert = document.createElement('span');
                alert.className = 'alert alert--error';
                if ( typeof response.description === 'string' ) {
                    alert.innerHTML = response.description;
                } else {
                    alert.innerHTML = response.message;
                }
                if (cartType == 'page' ) {
                    if ( document.getElementById('product-page-form-error-cart-alert') ) {
                        document.getElementById('product-page-form-error-cart-alert').remove();
                    }
                    alert.style.marginTop = '1em';
                    alert.style.marginBottom = '0';
                    alert.id = 'product-page-form-error-cart-alert';
                    productForm.parentElement.append(alert);
                    return false;
                }
            }
            return fetch('?section_id=helper-cart');
        })
        .then(response => response.text())
        // .then(text => {
        //
        //     const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
        //     const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
        //     const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
        //
        //     const cartItems = document.getElementById('AjaxCartForm');
        //     cartItems.innerHTML = cartFormInnerHTML;
        //     cartItems.ajaxifyCartItems();
        //
        //     if ( alert != '' ) {
        //         document.getElementById('AjaxCartForm').querySelector('form').prepend(alert);
        //     }
        //
        //     document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
        //
        //     document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
        //         //elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
        //     });
        //     document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
        //         elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
        //     });
        //
        //     document.dispatchEvent(ADD_TO_CART);
        //
        //     // a11y
        //     if ( document.getElementById('screen-reader-info') ) {
        //         document.getElementById('screen-reader-info').innerText = `${KROWN.settings.locales.cart_announcement}`;
        //         setTimeout(()=>{
        //             document.getElementById('screen-reader-info').innerText = '';
        //         }, 1000);
        //     }
        //
        // })
        .then(() => {
            let selectedStore = localStorage.getItem('selected-store');
            updateCartAttributes({ 'fulfilment-store': selectedStore }, true);
        })
        .then(() => {
            // document.querySelector('[aria-controls="site-cart-sidebar"]').click()
            // window.location.href = '/cart';
        })

        .catch(e => {
            console.log(e);
        })
        .finally(() => {
            submitButton.classList.remove('working');
        });
}

const _serializeForm = (form) => {
    let arr = [];
    Array.prototype.slice.call(form.elements).forEach(function(field) {
        if (
            !field.name ||
            field.disabled ||
            ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
        )
            return;
        if (field.type === 'select-multiple') {
            Array.prototype.slice.call(field.options).forEach(function(option) {
                if (!option.selected) return;

                try{
                    arr.push({
                        [field.name]: JSON.parse(option.value)
                    });
                }
                catch (e){
                    arr.push({
                        [field.name]: option.value
                    });
                }
            });
            return;
        }
        if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
            return;

        try{
            arr.push({[field.name]: JSON.parse(field.value)});
        }
        catch (e){
            arr.push({[field.name]: field.value});
        }
    });

    let finalJson = {};

    for(let i = 0; i< arr.length ; i++){
        let jsonKeys = Object.keys(arr[i])
        
        let currentPosition = arr[i];

        if(jsonKeys[0] !== 'form_type' && jsonKeys[0] !== 'section-id' && jsonKeys[0] !== 'utf8' && jsonKeys[0] !== 'product-id' ){
            finalJson[[jsonKeys[0]]] = currentPosition[[jsonKeys[0]]];
        }
    };

    return {"items": [finalJson]};
}